/* eslint-disable */
const getters = {
  getData(state) {
    return state.data;
  },
  getPaginationParams(state) {
    return state.paginationParams;
  },
  getIsLoaded(state) {
    return state.isLoaded;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
